import { render, staticRenderFns } from "./CaiDan.vue?vue&type=template&id=7231ff14&scoped=true"
import script from "./CaiDan.vue?vue&type=script&lang=js"
export * from "./CaiDan.vue?vue&type=script&lang=js"
import style0 from "./CaiDan.vue?vue&type=style&index=0&id=7231ff14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7231ff14",
  null
  
)

export default component.exports